import { j as d } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as D, useRef as H, useImperativeHandle as N, useMemo as g, createElement as V } from "react";
import { c as M } from "./index-DkZ16bcJ.mjs";
import { C as W } from "./checkbox-DiWnVoeQ.mjs";
import { f as z } from "./index-LyFokDcn.mjs";
import { m as J } from "./tss-DN0acMKN.mjs";
import { F as K } from "./field-context-CFgvjLYL.mjs";
import { G as O } from "./group-legend-1Z-tEAIm.mjs";
import { l as k } from "./lodash-5ofSKtz3.mjs";
import { _ as Q } from "./composeRefs-YONvD-rx.mjs";
import { L as U } from "./layout-box-DFBM-kSI.mjs";
import { S as X } from "./status-message-BMoS1d1Y.mjs";
import { F as Y } from "./FormControl-C7vROVtA.mjs";
import { g as Z } from "./get-aria-describedby-G1wcWKF2.mjs";
import { F as oo } from "./FormGroup-JbpzXay2.mjs";
function eo(n = "", r = "") {
  if (n) {
    const c = `${n}-checkbox-group`, a = r ? `-${r}` : "";
    return `${c}${a}`;
  }
}
function ro(n) {
  return n.filter((r) => r.checked).map((r) => r.value);
}
function no(n, r, c) {
  return n.map((a) => {
    const p = a.value === r.value ? r.checked : !!(a.checked || c != null && c.includes(a.value));
    return {
      ...a,
      checked: p
    };
  });
}
const co = J()(({ spacing: n }) => ({
  checkbox: {
    "&:nth-of-type(n+2)": {
      marginTop: z.ifFeature("encore", n(1.5), 8)
    }
  },
  root: {}
})), Io = D(
  ({
    apiRef: n,
    ariaDescribedby: r,
    biId: c,
    CheckboxProps: a = {},
    classes: p = {},
    className: R,
    containerRef: E,
    disabled: l,
    errorMessage: S,
    form: w,
    items: e = [],
    label: b,
    name: C,
    note: I,
    onBlur: L,
    onChange: P,
    required: j,
    size: q = "medium",
    status: f = "default",
    tabIndex: v,
    warningMessage: B,
    value: s
  }, T) => {
    const h = H(/* @__PURE__ */ new WeakMap());
    N(
      n,
      () => ({
        focus: () => {
          var G;
          const o = s && s.length > 0 ? e == null ? void 0 : e.findIndex((u) => u.value === s[0]) : -1, i = e == null ? void 0 : e.findIndex((u) => !u.disabled), t = o !== -1 ? o : i, m = e == null ? void 0 : e[t];
          if (t !== -1 && e) {
            const u = (G = h.current) == null ? void 0 : G.get(m);
            u && u.focus();
          }
        }
      }),
      [e, s]
    );
    const { classes: y } = co(), F = g(() => k.uniqueId("checkbox-group-note"), []), _ = g(() => k.uniqueId("radio-group-legend"), []), $ = g(() => k.uniqueId("status-message"), []), x = f === "error" ? S : B;
    function A(o, i) {
      const t = no(e, o, s);
      P(
        {
          updatedItems: t,
          value: ro(t)
        },
        i
      );
    }
    return /* @__PURE__ */ d.jsxs(
      Y,
      {
        "aria-describedby": Z(I ? F : "", x ? $ : "", r),
        "aria-invalid": f === "error",
        classes: {
          root: M(y.root, p.root)
        },
        className: R,
        component: "fieldset",
        "data-fabric-component": "CheckboxGroup",
        disabled: l,
        onBlur: L,
        ref: Q(T, E),
        required: j,
        children: [
          /* @__PURE__ */ d.jsxs("div", { "data-bi-id": eo(c, C), children: [
            b && /* @__PURE__ */ d.jsx(K.Provider, { value: { status: f, required: j, disabled: l, noteId: F }, children: /* @__PURE__ */ d.jsx(O, { id: _, label: b, note: I }) }),
            /* @__PURE__ */ d.jsx(
              oo,
              {
                classes: {
                  root: p.checkboxContainer
                },
                children: e.map((o, i) => {
                  const t = !!(s != null && s.includes(o.value) || o.checked);
                  return /* @__PURE__ */ V(
                    W,
                    {
                      ...a,
                      apiRef: (m) => {
                        h.current && h.current.set(o, m);
                      },
                      biId: c,
                      checked: t,
                      className: M(y.checkbox, p.checkbox),
                      disabled: l || o.disabled,
                      form: w,
                      id: o.id,
                      key: o.id || `${o.value}-${i}`,
                      label: o.label,
                      name: o.name || C,
                      note: o.note,
                      onChange: A,
                      size: q,
                      tabIndex: v,
                      value: o.value
                    }
                  );
                })
              }
            )
          ] }),
          x && (f === "error" || f === "warning") && /* @__PURE__ */ d.jsx(U, { marginTop: 1.5, children: /* @__PURE__ */ d.jsx(X, { id: $, message: x, status: f }) })
        ]
      }
    );
  }
);
export {
  Io as C
};
//# sourceMappingURL=checkbox-group-jz_F7j5y.mjs.map
